












import { Component, Prop, Vue } from "vue-property-decorator";
import { LayoutModule } from "@/store/layout";

@Component
export default class CampaignsReportSummary extends Vue {
  get loading(): boolean {
    return LayoutModule.loaderIsVisible;
  }

  details(): void {
    this.$router.push({
      name: "campaignsReport",
    });
  }
}
